var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "app" } }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "nav",
      [
        _c(
          "b-nav",
          { staticClass: "w-25", attrs: { vertical: "" } },
          [
            [
              _c(
                "div",
                {
                  ref: "dropdown0",
                  staticClass: "dropdown btn-group b-dropdown ani-dropdown",
                },
                [
                  _c(
                    "router-link",
                    { attrs: { to: { name: "Home" }, tag: "button" } },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "ani-nav-item home-button",
                        attrs: { icon: ["fas", "home"] },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-dropdown",
                {
                  ref: "dropdown1",
                  staticClass: "ani-dropdown2",
                  attrs: { size: "lg" },
                  scopedSlots: _vm._u([
                    {
                      key: "button-content",
                      fn: function () {
                        return [
                          _c("font-awesome-icon", {
                            staticClass: "ani-nav-item home-button",
                            attrs: { icon: ["fas", "file-contract"] },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _vm._v(" "),
                  _c(
                    "b-dropdown-item-button",
                    { attrs: { disabled: !_vm.logged } },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "ContractAdd" }, tag: "li" } },
                        [_vm._v(_vm._s(_vm.$t("label.new_contract")))]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-dropdown-item-button",
                    { attrs: { disabled: !_vm.logged } },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "Contracts" }, tag: "li" } },
                        [_vm._v(_vm._s(_vm.$t("label.list_contracts")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-dropdown",
                {
                  ref: "dropdown2",
                  staticClass: "ani-dropdown2",
                  scopedSlots: _vm._u([
                    {
                      key: "button-content",
                      fn: function () {
                        return [
                          _c("font-awesome-icon", {
                            staticClass: "ani-nav-item home-button",
                            attrs: { icon: ["fas", "hotel"] },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _vm._v(" "),
                  _c(
                    "b-dropdown-item-button",
                    { attrs: { disabled: !_vm.logged } },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: { to: { name: "Establishments" }, tag: "li" },
                        },
                        [_vm._v(_vm._s(_vm.$t("label.list_establishments")))]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-dropdown-item-button",
                    { attrs: { disabled: !_vm.logged } },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: { name: "EstablishmentEdit" },
                            tag: "li",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("label.new_establishment")))]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-dropdown-item-button",
                    { attrs: { disabled: !_vm.logged } },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: { name: "StatsEstablishments" },
                            tag: "li",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("label.stat_customer")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  ref: "dropdown3",
                  staticClass:
                    "dropdown btn-group b-dropdown ani-dropdown logout-button",
                },
                [
                  _c(
                    "router-link",
                    { attrs: { to: { name: "Logout" }, tag: "button" } },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "ani-nav-item power-off",
                        attrs: { icon: ["fas", "power-off"] },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            _vm._v(" "),
            _c("div", { staticClass: "version" }, [
              _vm._v(_vm._s(_vm.getVersion())),
            ]),
          ],
          2
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "main",
      [
        _c(
          "b-container",
          { attrs: { id: "main-container" } },
          [_c("router-view")],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", [_c("h1", [_vm._v("Back Office ANISEN")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }